import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

const ImageCreator = ({ imageName }) => {
  const images = useStaticQuery(graphql`
    query {
      day10Matrix: file(
        absolutePath: { regex: "/education/30days/day-10-matrix.png/" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      day10Square: file(
        absolutePath: { regex: "/education/30days/day-10-square.png/" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Image fluid={images[imageName].childImageSharp.fluid} alt={imageName} />
  )
}

export default [
  {
    _id: 0,
    title: "Course Overview",
    subtitle: "The transformation you'll be undertaking",
    time: "1:07",
    vid_link: "408897405",
    desc: "I'm looking forward to your next 30 days! Are you?",
  },
  {
    _id: 1,
    title: "Day 1: Define Happiness",
    subtitle: "Breaking down your vision of happiness.",
    time: "7:40",
    desc: (
      <div>
        <p>
          Restructuring your definition of &#x27;Happiness&#x27; using Western
          and Eastern world thoughts.
        </p>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>A Unified Theory of Happiness</em> by Andrea F. Polard:{" "}
          <a href="https://amzn.to/2vtb6Es" target="_blank">
            https://amzn.to/2vtb6Es
          </a>
        </p>
      </div>
    ),
    vid_link: "409803739",
  },
  {
    _id: 2,
    title: "Day 2: Define Success",
    subtitle:
      "Redefining your definition of ‘success’ using Aristotle’s method.",
    time: "5:42",
    desc: (
      <div>
        <p>
          Redefining your definition of ‘success’ using Aristotle’s method for
          building the definition.
        </p>
        <p>The 3 pieces that we use are:</p>
        <p>
          <strong>
            <em>Telos </em>
          </strong>
          – ‘End’, ‘Goal’, ‘Purpose’
        </p>
        <p>
          <strong>
            <em>Eudaimonia </em>
          </strong>
          – ‘Flourishing’, ‘Fulfilled’, ‘Happiness’
        </p>
        <p>
          <strong>
            <em>Arete </em>
          </strong>
          – ‘Skillset’, ‘Outstanding Specimen’
        </p>
        <p>
          <strong>
            <u>Homework:</u>
          </strong>
        </p>
        <p>Figure out your Telos. What do you want said at your funeral?</p>
      </div>
    ),
    vid_link: "409800638",
  },
  {
    _id: 3,
    title: "Day 3: Dont Be Your Hero",
    subtitle:
      "Why you should strive to be yourself instead of trying to be your hero/someone you’re not.",
    time: "5:59",
    desc: (
      <div>
        <p>
          Why you should strive to be yourself instead of trying to be your
          hero/someone you’re not.
        </p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Learn your Myers Briggs type indicator by either taking a test online
          or reading the book.. My favorite place to take a free test is:{" "}
          <a href="https://16personalities.com" target="_blank">
            https://16personalities.com
          </a>
        </p>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>Gifts Differing</em> by Isabel Briggs Myers and Peter B. Myers:{" "}
          <a href="https://amzn.to/2nvcvGd" target="_blank">
            https://amzn.to/2nvcvGd
          </a>
        </p>
      </div>
    ),
    vid_link: "409831466",
  },
  {
    _id: 4,
    title: "Day 4: S.M.A.R.T. Goals",
    subtitle: "Setting up your own S.M.A.R.T. goals.",
    time: "3:47",
    desc: (
      <div>
        <p>Setting up S.M.A.R.T. goals.</p>
        <p>S - Specific</p>
        <p>M - Measurable</p>
        <p>A - Attainable</p>
        <p>R - Relevant</p>
        <p>T - Time Bound</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Think of some goals that will lead you to your Telos.</p>
      </div>
    ),
    vid_link: "409807560",
  },
  {
    _id: 5,
    title: "Day 5: Setting Up Goals",
    subtitle: "Planning out long term goals!",
    time: "4:52",
    desc: (
      <div>
        <p>Building and breaking down goals</p>
        <p>Major Goal: Over a year to complete</p>
        <p>Macro Goal: 6-12 months to complete</p>
        <p>Micro Goal: A week – several months to complete</p>
        <p>Daily Goal: Completed in a day (Can be Mandatory or Peripheral)</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Break down your major goal (that aligns with your Telos) into Macro,
          Micro, and Daily. (See below attached image for ‘Goal Tree’ reference)
        </p>
      </div>
    ),
    vid_link: "409808646",
  },
  {
    _id: 6,
    title: "Day 6: Executing Goals",
    subtitle: "Executing Goals and sticking to the path.",
    time: "6:14",
    desc: (
      <div>
        <p>Executing Goals and sticking to the path.</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Write down your goals everyday.</p>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>The 10X Rule</em> by Grant Cardone:{" "}
          <a href="https://amzn.to/2vxj0wB" target="_blank">
            https://amzn.to/2vxj0wB
          </a>
        </p>
      </div>
    ),
    vid_link: "409809949",
  },
  {
    _id: 7,
    title: "Day 7: Time Managment",
    subtitle: "Tackling the mindset of time!",
    time: "9:09",
    desc: (
      <div>
        <p>I use onlinejobs.ph for outsourcing.</p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Trello - for Managing Tasks:{" "}
          <a href="https://trello.com" target="_blank">
            https://trello.com
          </a>
        </p>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>Flow</em> by Mihaly Csikszentmihalyi:{" "}
          <a href="https://amzn.to/2vy5J6N" target="_blank">
            https://amzn.to/2vy5J6N
          </a>
        </p>
      </div>
    ),
    vid_link: "409808843",
  },
  {
    _id: 8,
    title: "Day 8: Spending Your Time",
    subtitle: "How to appropriately manage your time.",
    time: "8:23",
    desc: (
      <div>
        <p>How to appropriately manage your time.</p>
        <p>The ideal breakdown</p>
        <p>Sleep: 8-9 hrs.</p>
        <p>Cooking/Cleaning: 2-3 hrs.</p>
        <p>Bathing/Grooming 1 hr.</p>
        <p>In Flow: 4-5 hrs.</p>
        <p>Free-time: 9 hrs.</p>
        <p>-1/3 of time with people above you.</p>
        <p>-1/3 of time with people at your level.</p>
        <p>-1/3 of time with people under you.</p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Tower Paddle Boards&#x27; Story:{" "}
          <a href="https://www.fastcompany.com/3063262" target="_blank">
            https://www.fastcompany.com/3063262
          </a>
        </p>
        <p>
          <strong>Homework: </strong>
        </p>
        <p>Divide days into hours and make sure your time is wasted.</p>
      </div>
    ),
    vid_link: "409810308",
  },
  {
    _id: 9,
    title: "Day 9: 99 Percent Are Wrong",
    subtitle: "Hear everything, but listen to little.",
    time: "5:13",
    desc: (
      <div>
        <p>Hear everything, but listen to little.</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Think of advice you’ve gotten recently and decide if it is in line
          with your Telos/Goals.
        </p>
      </div>
    ),
    vid_link: "409811024",
  },
  {
    _id: 10,
    title: "Day 10: Decision Making",
    subtitle:
      "Approaching both challenging and simple problems and how to respond to them.",
    time: "6:32",
    desc: (
      <div>
        <p>
          Eisenhower Matrix and Feedback Model seen below so you can follow
          along!
        </p>
        <div>
          <ImageCreator imageName={"day10Matrix"} />
          <ImageCreator imageName={"day10Square"} />
        </div>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>The Decision Book</em> by Mikael Krogerus:{" "}
          <a href="https://amzn.to/2AXVvSs" target="_blank">
            https://amzn.to/2AXVvSs
          </a>
        </p>
      </div>
    ),
    vid_link: "409811116",
  },
  {
    _id: 11,
    title: "Day 11: Persuasion",
    subtitle: "Manipulation is not Persuasion. Know the difference.",
    time: "9:11",
    desc: (
      <div>
        <p>Manipulation is not Persuasion. Know the difference.</p>
        <p>Further Reading:</p>
        <p>
          <em>How to Win Friends and Influence People</em> by Dale Carnegie:{" "}
          <a href="https://amzn.to/2OolELM" target="_blank">
            https://amzn.to/2OolELM
          </a>
        </p>
        <p>
          <em>The Way of the Wolf</em> by Jordan Belfort:{" "}
          <a href="https://amzn.to/2AWCGiv" target="_blank">
            https://amzn.to/2AWCGiv
          </a>
        </p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          When was a time you were persuaded? What method was used? When was a
          time you persuaded someone else? Did it work? Why/why not?
        </p>
      </div>
    ),
    vid_link: "409811171",
  },
  {
    _id: 12,
    title: "Day 12: Public Speaking",
    subtitle: "Communication through public speaking is incredibly powerful.",
    time: "7:30",
    desc: (
      <div>
        <p>Communication through public speaking is incredibly powerful.</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Practice public speaking with a small crowd.</p>
      </div>
    ),
    vid_link: "409814209",
  },
  {
    _id: 13,
    title: "Day 13: Finacial Control",
    subtitle: "Don't be a slave to the dollar.",
    time: "6:42",
    desc: (
      <div>
        <p>
          Make sure you control your money and that your money doesn’t control
          you.
        </p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Think about why you want/need more money… Is it justified?</p>
      </div>
    ),
    vid_link: "409814090",
  },
  {
    _id: 14,
    title: "Day 14: Spending Money",
    subtitle: "Try to limit spending and invest, invest, invest!",
    time: "11:15",
    desc: (
      <div>
        <p>Try to limit spending and invest, invest, invest!</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Use the below tools to get your spending right.</p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          My favorite tool to track expenses and stay on budget, Mint:{" "}
          <a href="https://mint.com" target="_blank">
            http://mint.com
          </a>
        </p>
        <p>
          Monthly Spending Calculator:{" "}
          <a
            href="https://docs.google.com/spreadsheets/d/1-FiVYQb7NnmLeAlSLI0NIeYCd201aG5VsPsYw8WBsjA/edit?usp=sharing"
            target="_blank"
          >
            https://docs.google.com/spreadsheets/d/1-FiVYQb7NnmLeAlSLI0NIeYCd201aG5VsPsYw8WBsjA/edit?usp=sharing
          </a>
        </p>
      </div>
    ),
    vid_link: "409814405",
  },
  {
    _id: 15,
    title: "Day 15: Personal Finance Strat",
    subtitle: "Personalizing your finance!",
    time: "9:20",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Check out some of the resources below and see if any of them make
          sense for you.
        </p>
        <p>
          More will be added as we go through the next few days! Keep in mind
          there are MANY MANY more investments out there and these few are just
          monetary. Focus on investing in yourself first and foremost; we will
          be talking about that tomorrow!
        </p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Ryan Scribner&#x27;s FREE Stock Course (Stock Investing) :{" "}
          <a
            href="https://stock-market-investing.teachable.com/p/how-to-find-a-great-investment"
            target="_blank"
          >
            https://stock-market-investing.teachable.com/p/how-to-find-a-great-investment
          </a>
        </p>
        <p>
          Bigger Pockets Blog (Real Estate) :{" "}
          <a href="https://www.biggerpockets.com/renewsblog" target="_blank">
            https://www.biggerpockets.com/renewsblog
          </a>
        </p>
        <p>
          Fundrise (Real Estate) :{" "}
          <a href="https://fundrise.com" target="_blank">
            https://fundrise.com
          </a>
        </p>
        <p>
          Lending Club (P2P) :{" "}
          <a href="https://www.lendingclub.com" target="_blank">
            https://www.lendingclub.com
          </a>
        </p>
      </div>
    ),
    vid_link: "409823013",
  },
  {
    _id: 16,
    title: "Day 16: Investing In Yourself",
    subtitle: "Your most valuable asset is YOU!",
    time: "11:49",
    desc: (
      <div>
        <p>Your most valuable asset is YOU.</p>
        <p>Resources:</p>
        <p>
          Brain Training Games from Lumosity:{" "}
          <a href="https://www.lumosity.com" target="_blank">
            https://www.lumosity.com
          </a>
        </p>
      </div>
    ),
    vid_link: "409842274",
  },
  {
    _id: 17,
    title: "Day 17: Increasing Your Income",
    subtitle: "Don’t chase money. Make money chase you.",
    time: "10:40",
    desc: (
      <div>
        <p>
          <em>“Don’t chase money. Make money chase you.”</em>
        </p>
        <p>
          There is so much opportunity to increase income it’s mind-boggling.
          The Technological Revolution has created so many ways to make plenty
          of income online.
        </p>
        <p>A few methods for increasing income</p>
        <p>1. Sell on Amazon</p>
        <p>2. Social Media Affiliate Marketing</p>
        <p>3. Sell Services (online or offline)</p>
        <p>4. Shotgun Method (Try a lot of stuff and see what sticks)</p>
        <p>Basic steps for increasing income:</p>
        <p>1. Find something you enjoy.</p>
        <p>2. Learn everything there is to know about it.</p>
        <p>3. Do that to make money AND/OR teach others to do it for money.</p>
        <p>
          I know you’re thinking: “That’s not in depth enough.. It’s harder than
          that.”
        </p>
        <p>
          Yes. Yes it is. BUT money=time+skill.. You MUST increase your skills
          (Arete) in order to be worthy to make the income you want. I cannot
          tell you what you will enjoy, but hopefully by now you have a good
          idea of your goals and can choose something you ENJOY.
        </p>
        <p>DO NOT CHASE MONEY. YOU WILL BE SAD IN THE END.</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Pick something you like and are slightly good at. Then think of ways
          to monetize that. Become an expert.
        </p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Learn from me how to sell on Amazon (great supplemental income):{" "}
          <a
            href="/education/amazon-millionaire-mentorship-program"
            target="_blank"
          >
            Amazon Millionaire Mentorship Program
          </a>
        </p>
      </div>
    ),
    vid_link: "409814513",
  },
  {
    _id: 18,
    title: "Day 18: Investing Money",
    subtitle: "Where to invest and the mirad of things to invest in.",
    time: "10:37",
    desc: (
      <div>
        <p>Methods of financial investing:</p>
        <ol>
          <li>Reinvesting in your own business</li>
          <li>Invest in other businesses (start-up/stocks/bonds)</li>
          <li>Trending/Short Term</li>
        </ol>
        <p>My stock spread (this is not financial advice, just FYI):</p>
        <ul className="fancy-checks">
          <li>10% VCLT</li>
          <li>10% VOO</li>
          <li>10% VEU</li>
          <li>20% VNQ</li>
          <li>20% VSS</li>
          <li>30% VBK</li>
        </ul>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Pick an investment strategy! It could be anything you think is the
          right fit for you.
        </p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Warren Buffet’s Portfolio:{" "}
          <a
            href="https://www.cnbc.com/berkshire-hathaway-portfolio"
            target="_blank"
          >
            https://www.cnbc.com/berkshire-hathaway-portfolio
          </a>
        </p>
        <p>
          Betterment (Stocks): 
          <a
            href="https://www.betterment.com/invite/jordankilburn"
            target="_blank"
          >
            https://www.betterment.com/invite/jordankilburn
          </a>
        </p>
        <p>
          Robinhood (Stocks):{" "}
          <a href="http://share.robinhood.com/jordank9" target="_blank">
            http://share.robinhood.com/jordank9
          </a>
        </p>
        <p>
          Merrill Edge(Stocks):{" "}
          <a href="https://www.merrilledge.com/" target="_blank">
            https://www.merrilledge.com
          </a>
        </p>
        <p>
          LendingClub (P2P):{" "}
          <a href="https://www.lendingclub.com/" target="_blank">
            https://www.lendingclub.com
          </a>
        </p>
        <p>
          Prosper (P2P):{" "}
          <a href="https://www.prosper.com/invest" target="_blank">
            https://www.prosper.com/invest
          </a>
        </p>
        <p>
          Real estate investment trusts “REITs” (Real Estate):{" "}
          <a href="https://www.reit.com/investing" target="_blank">
            https://www.reit.com/investing
          </a>
        </p>
        <p>
          Fundrise (Real Estate):{" "}
          <a href="https://fundrise.com/" target="_blank">
            https://fundrise.com
          </a>
        </p>
      </div>
    ),
    vid_link: "409869309",
  },
  {
    _id: 19,
    title: "Day 19: Dealing With Haters",
    subtitle: "Haters and doubters exist everywhere, but so do companions.",
    time: "8:13",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Make sure you have a core support group of at least 2-3 people.</p>
      </div>
    ),
    vid_link: "409814701",
  },
  {
    _id: 20,
    title: "Day 20: Being Likeable",
    subtitle: "What do Heroes and charismatic people have in common?",
    time: "5:45",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Do something nice for someone.</p>
      </div>
    ),
    vid_link: "409817347",
  },
  {
    _id: 21,
    title: "Day 21: Good Habits",
    subtitle: "The good habits of successful people.",
    time: "8:25",
    desc: (
      <div>
        <p>The good habits of successful people:</p>
        <p>1. Wake up early. (time to focus on important work)</p>
        <p>2. Read A LOT.</p>
        <p>3. Spend at least 30 minutes a day pondering about life.</p>
        <p>4. Exercise at least every other day.</p>
        <p>5. Plan out tomorrow, today.</p>
        <p>
          6. Compare yourself to your past self. Never compare yourself to other
          people.
        </p>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>The 7 Habits of Highly Effective People</em> by Stephen Covey:{" "}
          <a href="https://amzn.to/2OY9QB5" target="_blank">
            https://amzn.to/2OY9QB5
          </a>
           
        </p>
      </div>
    ),
    vid_link: "409817419",
  },
  {
    _id: 22,
    title: "Day 22: Personality Traits",
    subtitle: "Good traits that will improve your ability to grasp success!",
    time: "5:38",
    desc: (
      <div>
        <p>Successful Traits we discussed today</p>
        <p>1. Efficiency</p>
        <p>2. Organized</p>
        <p>3. Realistic</p>
        <p>4. Disciplined</p>
        <p>Resources:</p>
        <p>
          Trello:{" "}
          <a href="https://trello.com/" target="_blank">
            http://trello.com
          </a>
        </p>
        <p>
          Top Successful Traits:{" "}
          <a
            href="https://www.embracepossibility.com/blog/qualities-highly-successful-people"
            target="_blank"
          >
            https://www.embracepossibility.com/blog/qualities-highly-successful-people
          </a>
           
        </p>
      </div>
    ),
    vid_link: "409817622",
  },
  {
    _id: 23,
    title: "Day 23: Productivity",
    subtitle: "Ways to increase your actionable throughput.",
    time: "6:28",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Utilize the things we talked about today!</p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Google Drive:{" "}
          <a href="https://drive.google.com/" target="_blank">
            https://drive.google.com
          </a>
        </p>
        <p>
          Dropbox:{" "}
          <a href="https://www.dropbox.com/" target="_blank">
            https://www.dropbox.com
          </a>
        </p>
        <p>
          Trello:{" "}
          <a href="https://trello.com/" target="_blank">
            https://trello.com
          </a>
        </p>
        <p>
          Buffer:{" "}
          <a href="https://buffer.com/" target="_blank">
            https://buffer.com
          </a>
        </p>
        <p>
          Hootsuite:{" "}
          <a href="https://hootsuite.com/" target="_blank">
            https://hootsuite.com
          </a>
        </p>
        <p>
          PrimeNow:{" "}
          <a href="https://primenow.amazon.com/" target="_blank">
            https://primenow.amazon.com
          </a>{" "}
          (Amazon also has a house cleaning service)
        </p>
      </div>
    ),
    vid_link: "409817717",
  },
  {
    _id: 24,
    title: "Day 24: Exercise",
    subtitle:
      "Again… You’re most important asset is YOU. Take care of yourself!",
    time: "9:44",
    desc: (
      <div>
        <p>Again… You’re most important asset is YOU. Take care of yourself!</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>HIT THE GYM!</p>
      </div>
    ),
    vid_link: "409817793",
  },
  {
    _id: 25,
    title: "Day 25: Eating Healthy",
    subtitle:
      "Fuel for your body is important; having good clean fuel is just as important.",
    time: "9:00",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Start eating healthy. Be sure to drink plenty of water. A good daily
          estimate is 1 gallon. Get a blood test to ensure you’re getting enough
          of the right nutrients.
        </p>
      </div>
    ),
    vid_link: "409817911",
  },
  {
    _id: 26,
    title: "Day 26: Sleep",
    subtitle: "This is one of the biggest issues that plagues society!",
    time: "17:30",
    desc: (
      <div>
        <p>
          This is one of the longest lectures for a reason. This is one of the
          biggest issues among entrepreneurs and other business people.
        </p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Get a sleep app (the one I like is below, but feel free to use one you
          like) and start tracking your sleep.
        </p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Runtastic Sleep Tracking App (Android,iOS):{" "}
          <a href="https://www.runtastic.com/apps/sleepbetter" target="_blank">
            https://www.runtastic.com/apps/sleepbetter
          </a>
        </p>
      </div>
    ),
    vid_link: "409818072",
  },
  {
    _id: 27,
    title: "Day 27: Understanding Risk",
    subtitle:
      "Weighing and finding value in risk, when it is good and when it isn't.",
    time: "11:46",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Calculate the expected outcome of your favorite casino game 😊. Just
          for fun! (Don’t gamble)
        </p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Expected Value Mathematics:{" "}
          <a
            href="https://en.wikipedia.org/wiki/Expected_value"
            target="_blank"
          >
            https://en.wikipedia.org/wiki/Expected_value
          </a>
        </p>
      </div>
    ),
    vid_link: "410639443",
  },
  {
    _id: 28,
    title: "Day 28: Breaking And Forming Habits",
    subtitle: "Don't try to break them all at once.",
    time: "8:27",
    desc: (
      <div>
        <p>Don&#x27;t try to break them all at once.</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Pick your worst habit and BREAK IT!</p>
      </div>
    ),
    vid_link: "410639523",
  },
  {
    _id: 29,
    title: "Day 29: The Good Life Fast And The Best Life Slow",
    subtitle: "Start putting together a plan to get to the Good Life.",
    time: "5:15",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Start putting together a plan to get to the Good Life.</p>
      </div>
    ),
    vid_link: "410639628",
  },
  {
    _id: 30,
    title: "Day 30: Failing Along The Way",
    subtitle: "Failure is unavoidable, but how do you conquer it?",
    time: "6:45",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Talk about a recent failure with someone.</p>
      </div>
    ),
    vid_link: "409818197",
  },
  {
    _id: 31,
    title: "Day 31: Moving Forward",
    subtitle:
      "I’ve loved going through your First 30 Days with you and I hope you’ve enjoyed it to!",
    time: "4:10",
    vid_link:"410639705",
    desc: (
      <div>
        <p>
          I’ve loved going through your First 30 Days with you and I hope you’ve
          enjoyed it to! Be sure to connect with me on social media and see what
          I’m up to!
        </p>
        <p>
          <strong>My social media:</strong>
        </p>
        <p>
          Instagram:{" "}
          <a href="https://www.instagram.com/jordan_kilburn" target="_blank">
            https://www.instagram.com/jordan_kilburn
          </a>
        </p>
        <p>
          Facebook:{" "}
          <a
            href="https://www.facebook.com/TheMillionaireMillennial"
            target="_blank"
          >
            https://www.facebook.com/TheMillionaireMillennial
          </a>
        </p>
        <p>
          Twitter:{" "}
          <a href="https://twitter.com/JordanKilburn" target="_blank">
            https://twitter.com/JordanKilburn
          </a>
        </p>
        <p>
          Snapchat:{" "}
          <a href="https://www.snapchat.com/add/jordan.kilburn" target="_blank">
            https://www.snapchat.com/add/jordan.kilburn
          </a>
        </p>
        <p>
          YouTube:{" "}
          <a
            href="https://www.youtube.com/channel/UCfJ9eqFDUH9cjWinKeY0kag"
            target="_blank"
          >
            https://www.youtube.com/channel/UCfJ9eqFDUH9cjWinKeY0kag
          </a>
        </p>
      </div>
    ),
  },
]

const oldOne = [
  {
    _id: 100,
    title: "Course Overview",
    subtitle: "The transformation you'll be undertaking",
    time: "1:07",
    vid_link: "408897405",
    desc: "I'm looking forward to your next 30 days! Are you?",
  },
  {
    _id: 1,
    title: "Day 1: Define Happiness",
    subtitle: "Breaking down your vision of happiness.",
    time: "7:40",
    desc: (
      <div>
        <p>
          Restructuring your definition of 'Happiness' using Western and Eastern
          world thoughts.
        </p>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>A Unified Theory of Happiness</em> by Andrea F. Polard:{" "}
          <a href="https://amzn.to/2vtb6Es" target="_blank">
            https://amzn.to/2vtb6Es
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 2,
    title: "Day 2: Define Success",
    subtitle:
      "Redefining your definition of ‘success’ using Aristotle’s method.",
    time: "5:42",
    desc: (
      <div>
        <p>
          Redefining your definition of &lsquo;success&rsquo; using
          Aristotle&rsquo;s method for building the definition.
        </p>
        <p>The 3 pieces that we use are:</p>
        <p>
          <strong>
            <em>Telos </em>
          </strong>
          &ndash; &lsquo;End&rsquo;, &lsquo;Goal&rsquo;, &lsquo;Purpose&rsquo;
        </p>
        <p>
          <strong>
            <em>Eudaimonia </em>
          </strong>
          &ndash; &lsquo;Flourishing&rsquo;, &lsquo;Fulfilled&rsquo;,
          &lsquo;Happiness&rsquo;
        </p>
        <p>
          <strong>
            <em>Arete </em>
          </strong>
          &ndash; &lsquo;Skillset&rsquo;, &lsquo;Outstanding Specimen&rsquo;
        </p>
        <p>
          <strong>
            <u>Homework:</u>
          </strong>
        </p>
        <p>Figure out your Telos. What do you want said at your funeral?</p>
      </div>
    ),
  },
  {
    _id: 3,
    title: "Day 3: Dont Be Your Hero",
    subtitle:
      "Why you should strive to be yourself instead of trying to be your hero/someone you’re not.",
    time: "5:59",
    desc: (
      <div>
        <p>
          Why you should strive to be yourself instead of trying to be your
          hero/someone you&rsquo;re not.
        </p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Learn your Myers Briggs type indicator by either taking a test online
          or reading the book.. My favorite place to take a free test is:{" "}
          <a href="https://16personalities.com" target="_blank">
            https://16personalities.com
          </a>
        </p>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>Gifts Differing</em> by Isabel Briggs Myers&nbsp;and Peter B.
          Myers:{" "}
          <a href="https://amzn.to/2nvcvGd" target="_blank">
            https://amzn.to/2nvcvGd
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 4,
    title: "Day 4: S.M.A.R.T. Goals",
    subtitle: "Setting up your own S.M.A.R.T. goals.",
    time: "3:47",
    desc: (
      <div>
        <p>Setting up S.M.A.R.T. goals.</p>
        <p>S - Specific</p>
        <p>M - Measurable</p>
        <p>A - Attainable</p>
        <p>R - Relevant</p>
        <p>T - Time Bound</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Think of some goals that will lead you to your Telos.</p>
      </div>
    ),
  },
  {
    _id: 5,
    title: "Day 5: Setting Up Goals",
    subtitle: "Planning out long term goals!",
    time: "4:52",
    desc: (
      <div>
        <p>Building and breaking down goals</p>
        <p>Major Goal: Over a year to complete</p>
        <p>Macro Goal: 6-12 months to complete</p>
        <p>Micro Goal: A week &ndash; several months to complete</p>
        <p>Daily Goal: Completed in a day (Can be Mandatory or Peripheral)</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Break down your major goal (that aligns with your Telos) into Macro,
          Micro, and Daily. (See below attached image for &lsquo;Goal
          Tree&rsquo; reference)
        </p>
      </div>
    ),
  },
  {
    _id: 6,
    title: "Day 6: Executing Goals",
    subtitle: "Executing Goals and sticking to the path.",
    time: "6:14",
    desc: (
      <div>
        <p>Executing Goals and sticking to the path.</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Write down your goals everyday.</p>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>The 10X Rule</em> by Grant Cardone:{" "}
          <a href="https://amzn.to/2vxj0wB" target="_blank">
            https://amzn.to/2vxj0wB
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 7,
    title: "Day 7: Time Managment",
    subtitle: "Tackling the mindset of time!",
    time: "9:09",
    desc: (
      <div>
        <p>I use onlinejobs.ph for outsourcing.</p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Trello - for Managing Tasks:{" "}
          <a href="https://trello.com" target="_blank">
            https://trello.com
          </a>
        </p>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>Flow</em> by Mihaly Csikszentmihalyi:{" "}
          <a href="https://amzn.to/2vy5J6N" target="_blank">
            https://amzn.to/2vy5J6N
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 8,
    title: "Day 8: Spending Your Time",
    subtitle: "How to appropriately manage your time.",
    time: "8:23",
    desc: (
      <div>
        <p>How to appropriately manage your time.</p>
        <p>The ideal breakdown</p>
        <p>Sleep: 8-9 hrs.</p>
        <p>Cooking/Cleaning: 2-3 hrs.</p>
        <p>Bathing/Grooming 1 hr.</p>
        <p>In Flow: 4-5 hrs.</p>
        <p>Free-time: 9 hrs.</p>
        <p>-1/3 of time with people above you.</p>
        <p>-1/3 of time with people at your level.</p>
        <p>-1/3 of time with people under you.</p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Tower Paddle Boards' Story:{" "}
          <a href="https://www.fastcompany.com/3063262" target="_blank">
            https://www.fastcompany.com/3063262
          </a>
        </p>
        <p>
          <strong>Homework: </strong>
        </p>
        <p>Divide days into hours and make sure your time is wasted.</p>
      </div>
    ),
  },
  {
    _id: 9,
    title: "Day 9: 99 Percent Are Wrong",
    subtitle: "Hear everything, but listen to little.",
    time: "5:13",
    desc: (
      <div>
        <p>Hear everything, but listen to little.</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Think of advice you&rsquo;ve gotten recently and decide if it is in
          line with your Telos/Goals.
        </p>
      </div>
    ),
  },
  {
    _id: 10,
    title: "Day 10: Decision Making",
    subtitle:
      "Approaching both challenging and simple problems and how to respond to them.",
    time: "6:32",
    desc: (
      <div>
        <p>
          Eisenhower Matrix and Feedback Model seen below so you can follow
          along!
        </p>
        <div>
          {/* <ImageCreator imageName={"day10Matrix"} />
          <ImageCreator imageName={"day10Square"} /> */}
        </div>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>The Decision Book</em> by Mikael Krogerus:{" "}
          <a href="https://amzn.to/2AXVvSs" target="_blank">
            https://amzn.to/2AXVvSs
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 11,
    title: "Day 11: Persuasion",
    subtitle: "Manipulation is not Persuasion. Know the difference.",
    time: "9:11",
    desc: (
      <div>
        <p>Manipulation is not Persuasion. Know the difference.</p>
        <p>Further Reading:</p>
        <p>
          <em>How to Win Friends and Influence People</em> by Dale Carnegie:{" "}
          <a href="https://amzn.to/2OolELM" target="_blank">
            https://amzn.to/2OolELM
          </a>
        </p>
        <p>
          <em>The Way of the Wolf</em> by Jordan Belfort:{" "}
          <a href="https://amzn.to/2AWCGiv" target="_blank">
            https://amzn.to/2AWCGiv
          </a>
        </p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          When was a time you were persuaded? What method was used? When was a
          time you persuaded someone else? Did it work? Why/why not?
        </p>
      </div>
    ),
  },
  {
    _id: 12,
    title: "Day 12: Public Speaking",
    subtitle: "Communication through public speaking is incredibly powerful.",
    time: "7:30",
    desc: (
      <div>
        <p>Communication through public speaking is incredibly powerful.</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Practice public speaking with a small crowd.</p>
      </div>
    ),
  },
  {
    _id: 13,
    title: "Day 13: Finacial Control",
    subtitle: "Don't be a slave to the dollar.",
    time: "6:42",
    desc: (
      <div>
        <p>
          Make sure you control your money and that your money doesn&rsquo;t
          control you.
        </p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Think about why you want/need more money&hellip; Is it justified?</p>
      </div>
    ),
  },
  {
    _id: 14,
    title: "Day 14: Spending Money",
    subtitle: "Try to limit spending and invest, invest, invest!",
    time: "11:15",
    desc: (
      <div>
        <p>Try to limit spending and invest, invest, invest!</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Use the below tools to get your spending right.</p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          My favorite tool to track expenses and stay on budget, Mint:{" "}
          <a href="https://mint.com" target="_blank">
            http://mint.com
          </a>
        </p>
        <p>
          Monthly Spending Calculator:{" "}
          <a
            href="https://docs.google.com/spreadsheets/d/1-FiVYQb7NnmLeAlSLI0NIeYCd201aG5VsPsYw8WBsjA/edit?usp=sharing"
            target="_blank"
          >
            https://docs.google.com/spreadsheets/d/1-FiVYQb7NnmLeAlSLI0NIeYCd201aG5VsPsYw8WBsjA/edit?usp=sharing
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 15,
    title: "Day 15: Personal Finance Strat",
    subtitle: "Personalizing your finance!",
    time: "9:20",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Check out some of the resources below and see if any of them make
          sense for you.
        </p>
        <p>
          More will be added as we go through the next few days! Keep in mind
          there are MANY MANY more investments out there and these few are just
          monetary. Focus on investing in yourself first and foremost; we will
          be talking about that tomorrow!
        </p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Ryan Scribner's FREE Stock Course (Stock Investing) :{" "}
          <a
            href="https://stock-market-investing.teachable.com/p/how-to-find-a-great-investment"
            target="_blank"
          >
            https://stock-market-investing.teachable.com/p/how-to-find-a-great-investment
          </a>
        </p>
        <p>
          Bigger Pockets Blog (Real Estate) :{" "}
          <a href="https://www.biggerpockets.com/renewsblog" target="_blank">
            https://www.biggerpockets.com/renewsblog
          </a>
        </p>
        <p>
          Fundrise (Real Estate) :{" "}
          <a href="https://fundrise.com" target="_blank">
            https://fundrise.com
          </a>
        </p>
        <p>
          Lending Club (P2P) :{" "}
          <a href="https://www.lendingclub.com" target="_blank">
            https://www.lendingclub.com
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 16,
    title: "Day 16: Investing In Yourself",
    subtitle: "Your most valuable asset is YOU!",
    time: "11:49",
    desc: (
      <div>
        <p>Your most valuable asset is YOU.</p>
        <p>Resources:</p>
        <p>
          Brain Training Games from Lumosity:{" "}
          <a href="https://www.lumosity.com" target="_blank">
            https://www.lumosity.com
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 17,
    title: "Day 17: Increasing Your Income",
    subtitle: "Don’t chase money. Make money chase you.",
    time: "10:40",
    desc: (
      <div>
        <p>
          <em>&ldquo;Don&rsquo;t chase money. Make money chase you.&rdquo;</em>
        </p>
        <p>
          There is so much opportunity to increase income it&rsquo;s
          mind-boggling. The Technological Revolution has created so many ways
          to make plenty of income online.
        </p>
        <p>A few methods for increasing income</p>
        <p>1.&nbsp;Sell on Amazon</p>
        <p>2.&nbsp;Social Media Affiliate Marketing</p>
        <p>3.&nbsp;Sell Services (online or offline)</p>
        <p>4.&nbsp;Shotgun Method (Try a lot of stuff and see what sticks)</p>
        <p>Basic steps for increasing income:</p>
        <p>1.&nbsp;Find something you enjoy.</p>
        <p>2.&nbsp;Learn everything there is to know about it.</p>
        <p>
          3.&nbsp;Do that to make money AND/OR teach others to do it for money.
        </p>
        <p>
          I know you&rsquo;re thinking: &ldquo;That&rsquo;s not in depth
          enough.. It&rsquo;s harder than that.&rdquo;
        </p>
        <p>
          Yes. Yes it is. BUT money=time+skill.. You MUST increase your skills
          (Arete) in order to be worthy to make the income you want. I cannot
          tell you what you will enjoy, but hopefully by now you have a good
          idea of your goals and can choose something you ENJOY.
        </p>
        <p>DO NOT CHASE MONEY. YOU WILL BE SAD IN THE END.</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Pick something you like and are slightly good at. Then think of ways
          to monetize that. Become an expert.
        </p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Learn from me how to sell on Amazon (great supplemental income):{" "}
          <a
            href="/education/amazon-millionaire-mentorship-program"
            target="_blank"
          >
            Amazon Millionaire Mentorship Program
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 18,
    title: "Day 18: Investing Money",
    subtitle: "Where to invest and the mirad of things to invest in.",
    time: "10:37",
    desc: (
      <div>
        <p>Methods of financial investing:</p>
        <ol>
          <li>Reinvesting in your own business</li>
          <li>Invest in other businesses (start-up/stocks/bonds)</li>
          <li>Trending/Short Term</li>
        </ol>
        <p>My stock spread (this is not financial advice, just FYI):</p>
        <ul className="fancy-checks">
          <li>10% VCLT</li>
          <li>10% VOO</li>
          <li>10% VEU</li>
          <li>20% VNQ</li>
          <li>20% VSS</li>
          <li>30% VBK</li>
        </ul>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Pick an investment strategy! It could be anything you think is the
          right fit for you.
        </p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Warren Buffet&rsquo;s Portfolio:{" "}
          <a
            href="https://www.cnbc.com/berkshire-hathaway-portfolio"
            target="_blank"
          >
            https://www.cnbc.com/berkshire-hathaway-portfolio
          </a>
        </p>
        <p>
          Betterment (Stocks):&nbsp;
          <a
            href="https://www.betterment.com/invite/jordankilburn"
            target="_blank"
          >
            https://www.betterment.com/invite/jordankilburn
          </a>
        </p>
        <p>
          Robinhood (Stocks):{" "}
          <a href="http://share.robinhood.com/jordank9" target="_blank">
            http://share.robinhood.com/jordank9
          </a>
        </p>
        <p>
          Merrill Edge(Stocks):{" "}
          <a href="https://www.merrilledge.com/" target="_blank">
            https://www.merrilledge.com
          </a>
        </p>
        <p>
          LendingClub (P2P):{" "}
          <a href="https://www.lendingclub.com/" target="_blank">
            https://www.lendingclub.com
          </a>
        </p>
        <p>
          Prosper (P2P):{" "}
          <a href="https://www.prosper.com/invest" target="_blank">
            https://www.prosper.com/invest
          </a>
        </p>
        <p>
          Real estate investment trusts &ldquo;REITs&rdquo; (Real Estate):{" "}
          <a href="https://www.reit.com/investing" target="_blank">
            https://www.reit.com/investing
          </a>
        </p>
        <p>
          Fundrise (Real Estate):{" "}
          <a href="https://fundrise.com/" target="_blank">
            https://fundrise.com
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 19,
    title: "Day 19: Dealing With Haters",
    subtitle: "Haters and doubters exist everywhere, but so do companions.",
    time: "8:13",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Make sure you have a core support group of at least 2-3 people.</p>
      </div>
    ),
  },
  {
    _id: 20,
    title: "Day 20: Being Likeable",
    subtitle: "What do Heroes and charismatic people have in common?",
    time: "5:45",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Do something nice for someone.</p>
      </div>
    ),
  },
  {
    _id: 21,
    title: "Day 21: Good Habits",
    subtitle: "The good habits of successful people.",
    time: "8:25",
    desc: (
      <div>
        <p>The good habits of successful people:</p>
        <p>1. Wake up early. (time to focus on important work)</p>
        <p>2. Read A LOT.</p>
        <p>3. Spend at least 30 minutes a day pondering about life.</p>
        <p>4. Exercise at least every other day.</p>
        <p>5. Plan out tomorrow, today.</p>
        <p>
          6. Compare yourself to your past self. Never compare yourself to other
          people.
        </p>
        <p>
          <strong>Further Reading:</strong>
        </p>
        <p>
          <em>The 7 Habits of Highly Effective People</em> by Stephen Covey:{" "}
          <a href="https://amzn.to/2OY9QB5" target="_blank">
            https://amzn.to/2OY9QB5
          </a>
          &nbsp;
        </p>
      </div>
    ),
  },
  {
    _id: 22,
    title: "Day 22: Personality Traits",
    subtitle: "Good traits that will improve your ability to grasp success!",
    time: "5:38",
    desc: (
      <div>
        <p>Successful Traits we discussed today</p>
        <p>1. Efficiency</p>
        <p>2. Organized</p>
        <p>3. Realistic</p>
        <p>4. Disciplined</p>
        <p>Resources:</p>
        <p>
          Trello:{" "}
          <a href="https://trello.com/" target="_blank">
            http://trello.com
          </a>
        </p>
        <p>
          Top Successful Traits:{" "}
          <a
            href="https://www.embracepossibility.com/blog/qualities-highly-successful-people"
            target="_blank"
          >
            https://www.embracepossibility.com/blog/qualities-highly-successful-people
          </a>
          &nbsp;
        </p>
      </div>
    ),
  },
  {
    _id: 23,
    title: "Day 23: Productivity",
    subtitle: "Ways to increase your actionable throughput.",
    time: "6:28",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Utilize the things we talked about today!</p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Google Drive:{" "}
          <a href="https://drive.google.com/" target="_blank">
            https://drive.google.com
          </a>
        </p>
        <p>
          Dropbox:{" "}
          <a href="https://www.dropbox.com/" target="_blank">
            https://www.dropbox.com
          </a>
        </p>
        <p>
          Trello:{" "}
          <a href="https://trello.com/" target="_blank">
            https://trello.com
          </a>
        </p>
        <p>
          Buffer:{" "}
          <a href="https://buffer.com/" target="_blank">
            https://buffer.com
          </a>
        </p>
        <p>
          Hootsuite:{" "}
          <a href="https://hootsuite.com/" target="_blank">
            https://hootsuite.com
          </a>
        </p>
        <p>
          PrimeNow:{" "}
          <a href="https://primenow.amazon.com/" target="_blank">
            https://primenow.amazon.com
          </a>{" "}
          (Amazon also has a house cleaning service)
        </p>
      </div>
    ),
  },
  {
    _id: 24,
    title: "Day 24: Exercise",
    subtitle:
      "Again… You’re most important asset is YOU. Take care of yourself!",
    time: "9:44",
    desc: (
      <div>
        <p>
          Again&hellip; You&rsquo;re most important asset is YOU. Take care of
          yourself!
        </p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>HIT THE GYM!</p>
      </div>
    ),
  },
  {
    _id: 25,
    title: "Day 25: Eating Healthy",
    subtitle:
      "Fuel for your body is important; having good clean fuel is just as important.",
    time: "9:00",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Start eating healthy. Be sure to drink plenty of water. A good daily
          estimate is 1 gallon. Get a blood test to ensure you&rsquo;re getting
          enough of the right nutrients.
        </p>
      </div>
    ),
  },
  {
    _id: 26,
    title: "Day 26: Sleep",
    subtitle: "This is one of the biggest issues that plagues society!",
    time: "17:30",
    desc: (
      <div>
        <p>
          This is one of the longest lectures for a reason. This is one of the
          biggest issues among entrepreneurs and other business people.
        </p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Get a sleep app (the one I like is below, but feel free to use one you
          like) and start tracking your sleep.
        </p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Runtastic Sleep Tracking App (Android,iOS):{" "}
          <a href="https://www.runtastic.com/apps/sleepbetter" target="_blank">
            https://www.runtastic.com/apps/sleepbetter
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 27,
    title: "Day 27: Understanding Risk",
    subtitle:
      "Weighing and finding value in risk, when it is good and when it isn't.",
    time: "11:46",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>
          Calculate the expected outcome of your favorite casino game 😊. Just
          for fun! (Don&rsquo;t gamble)
        </p>
        <p>
          <strong>Resources:</strong>
        </p>
        <p>
          Expected Value Mathematics:{" "}
          <a
            href="https://en.wikipedia.org/wiki/Expected_value"
            target="_blank"
          >
            https://en.wikipedia.org/wiki/Expected_value
          </a>
        </p>
      </div>
    ),
  },
  {
    _id: 28,
    title: "Day 28: Breaking And Forming Habits",
    subtitle: "Don't try to break them all at once.",
    time: "8:27",
    desc: (
      <div>
        <p>Don't try to break them all at once.</p>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Pick your worst habit and BREAK IT!</p>
      </div>
    ),
  },
  {
    _id: 29,
    title: "Day 29: The Good Life Fast And The Best Life Slow",
    subtitle: "Start putting together a plan to get to the Good Life.",
    time: "5:15",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Start putting together a plan to get to the Good Life.</p>
      </div>
    ),
  },
  {
    _id: 30,
    title: "Day 30: Failing Along The Way",
    subtitle: "Failure is unavoidable, but how do you conquer it?",
    time: "6:45",
    desc: (
      <div>
        <p>
          <strong>Homework:</strong>
        </p>
        <p>Talk about a recent failure with someone.</p>
      </div>
    ),
  },
  {
    _id: 31,
    title: "Day 31: Moving Forward",
    subtitle:
      "I’ve loved going through your First 30 Days with you and I hope you’ve enjoyed it to!",
    time: "4:10",
    desc: (
      <div>
        <p>
          I&rsquo;ve loved going through your First 30 Days with you and I hope
          you&rsquo;ve enjoyed it to! Be sure to connect with me on social media
          and see what I&rsquo;m up to!
        </p>
        <p>
          <strong>My social media:</strong>
        </p>
        <p>
          Instagram:{" "}
          <a href="https://www.instagram.com/jordan_kilburn" target="_blank">
            https://www.instagram.com/jordan_kilburn
          </a>
        </p>
        <p>
          Facebook:{" "}
          <a
            href="https://www.facebook.com/TheMillionaireMillennial"
            target="_blank"
          >
            https://www.facebook.com/TheMillionaireMillennial
          </a>
        </p>
        <p>
          Twitter:{" "}
          <a href="https://twitter.com/JordanKilburn" target="_blank">
            https://twitter.com/JordanKilburn
          </a>
        </p>
        <p>
          Snapchat:{" "}
          <a href="https://www.snapchat.com/add/jordan.kilburn" target="_blank">
            https://www.snapchat.com/add/jordan.kilburn
          </a>
        </p>
        <p>
          YouTube:{" "}
          <a
            href="https://www.youtube.com/channel/UCfJ9eqFDUH9cjWinKeY0kag"
            target="_blank"
          >
            https://www.youtube.com/channel/UCfJ9eqFDUH9cjWinKeY0kag
          </a>
        </p>
      </div>
    ),
  },
]
